export enum VehicleMessages {

  DAYS_TO_ALERT_EXPIRATION_DEFAULT = 30,
  DAYS_TO_BLOCK_DEFAULT = 7,
  DAYS_TO_DEACTIVE_VEHICLES_DEFAULT = 60,

  RTM_NO_INFORMATION = 'No hay información de la RTM.',
  RTM_NO_EXPIRATION = 'No hay información de la fecha de vencimiento de la RTM.',
  RTM_EXONERATED = 'El vehículo se encuentra exonerado de la RTM por ser nuevo',
  RTM_POSSIBLE_EXONERATED = 'El vehículo se encuentra en su último año de exoneración de la RTM',
  RTM_VALID = 'RTM válida.',
  RTM_MORE_N_DAYS = 'RTM válida y con vigencia mayor a %s días desde la fecha de llegada.',
  RTM_LESS_ALERT_N_DAYS = 'La RTM expirará en menos de %s días desde la fecha de llegada.',
  RTM_LESS_BLOCK_N_DAYS = '¡La RTM expirará en menos de %s días desde la fecha de llegada!',
  RTM_EXPIRATED = 'La RTM estará vencida para la fecha de llegada.',
  RTM_EXPIRED_NOW = 'La RTM está vencida actualmente.',
  RTM_EXPIRATION_DATE_REQUIRED = "La fecha de vencimiento de la RTM es obligatoria",

  SOAT_NO_INFORMATION = 'No hay información del SOAT.',
  SOAT_NO_EXPIRATION = 'No hay información de la fecha de vencimiento del SOAT.',
  SOAT_VALID = 'SOAT válido.',
  SOAT_MORE_N_DAYS = 'SOAT válido y con vigencia mayor a %s días desde la fecha de llegada.',
  SOAT_LESS_ALERT_N_DAYS = 'El SOAT expirará en menos de %s días desde la fecha de llegada.',
  SOAT_LESS_BLOCK_N_DAYS = '¡El SOAT expirará en menos de %s días desde la fecha de llegada!',
  SOAT_EXPIRATED = 'El SOAT estará vencido para la fecha de llegada.',
  SOAT_EXPIRED_NOW = 'El SOAT está vencido actualmente.',
  SOAT_INSURANCE_COMPANY_REQUIRED = "La compañía de seguros del SOAT es obligatoria",
  SOAT_POLICY_NUMBER_REQUIRED = "El número del seguro SOAT es obligatorio",

  NO_VEHICLE_TYPE_NAME = "Falta especificar el tipo de vehículo en la información general del vehículo.",
  NO_VEHICLE_BODYWORK_TYPE_NAME = "Falta especificar el tipo de carrocería en la información general del vehículo.",
  NO_VEHICLE_GROSS_WEIGHT = "Falta registrar el peso bruto en la información general del vehículo",
  NO_CARGO_VEHICLE_NAME = "El servicio no tiene un tipo de vehículo asignado",
  STATE_INACTIVE = "El vehículo seleccionado no esta activo",
  SECURITY_STUDY_IN_PROCESS = "El vehículo seleccionado se encuentra en estudio de seguridad",
  DRIVER_STATE_INACTIVE = "El conductor de este vehículo no está activo",
  OWNER_STATE_INACTIVE = "El propietario de este vehículo no está activo",
  ADMIN_STATE_INACTIVE = "El administrador de este vehículo no está activo",
  VEHICLE_TYPE_DIFF = "El vehículo seleccionado es de tipo %s, el servicio permite vehículos tipo %s",
  VEHICLE_DOCUMENTATION_INCOMPLETE = "El vehículo no tiene cargada la documentación obligatoria. Falta(n):",
  VEHICLE_DOCUMENTATION_UNACCEPTED = "Hay documentación obligatoria que no ha sido validada por tráfico. Falta(n):",
  VEHICLE_REFERENCES_UNACCEPTED = "Hay referencias y contactos que no han sido validados por tráfico. Falta(n):",
  NOT_VEHICLE_SELECTED = "No se ha seleccionado un vehículo",
  VEHICLE_REGISTRATION_DATE_REQUIRED = "Falta registrar la fecha de matriculación del vehículo",
  VEHICLE_AXLES_REQUIRED = "Falta registrar el número de ejes del vehículo",
  VEHICLE_EMPTY_WEIGHT_REQUIRED = "Falta registrar el peso vacío del vehículo",
  VEHICLE_SERVICE_TYPE_REQUIRED = "Falta especificar el tipo de servicio (Particular o público) en la información general del vehículo",
  VEHICLE_MANUFACTURING_YEAR_REQUIRED = "Falta registrar el año modelo del vehículo"
}
